import React from 'react';
import './KanJegReise.css';

/**
 * "Kan jeg reise?"-komponent for mobil
 * Viser kritiske mangler som MÅ fikses på stedet
 * og advarsler som kan gjøres på kontoret
 */
function KanJegReise({ validation, onClose, onFixError }) {
  const { canLeave, kritiskeFeil, advarsler, message } = validation;

  return (
    <div className="kan-jeg-reise-overlay">
      <div className="kan-jeg-reise-modal">
        {/* Header */}
        <div className={`kjr-header ${canLeave ? 'success' : 'error'}`}>
          <h2>🚗 KAN JEG REISE?</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        {/* Resultat */}
        <div className={`kjr-result ${canLeave ? 'can-leave' : 'cannot-leave'}`}>
          <div className="result-icon">
            {canLeave ? '✅' : '🚫'}
          </div>
          <h3>{message}</h3>
        </div>

        {/* Kritiske feil */}
        {kritiskeFeil.length > 0 && (
          <div className="kjr-section kritisk">
            <h4>🔴 KRITISKE MANGLER ({kritiskeFeil.length})</h4>
            <p className="kjr-description">
              Disse MÅ fikses på stedet - kan ikke gjøres på kontoret:
            </p>

            <div className="error-list">
              {kritiskeFeil.map((feil, idx) => (
                <div key={idx} className="error-item critical">
                  <div className="error-icon">🔴</div>
                  <div className="error-content">
                    <div className="error-title">
                      {feil.bygningsdel && <strong>{feil.bygningsdel}:</strong>} {feil.message}
                    </div>
                    <button
                      className="fix-btn"
                      onClick={() => onFixError(feil)}
                    >
                      {feil.action === 'take_photo' && '📸 Ta bilder nå'}
                      {feil.action === 'edit_tgiu' && '✏️ Legg til begrunnelse'}
                      {feil.action === 'navigate' && '🔍 Gå til område'}
                      {!['take_photo', 'edit_tgiu', 'navigate'].includes(feil.action) && '→ Fiks nå'}
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {kritiskeFeil.length > 0 && (
              <div className="time-estimate">
                <p>⏱️ Estimert tid: {Math.max(10, kritiskeFeil.length * 5)} minutter</p>
              </div>
            )}
          </div>
        )}

        {/* Advarsler (kan gjøres på kontoret) */}
        {advarsler.length > 0 && (
          <div className="kjr-section advarsel">
            <h4>⚠️ ADVARSLER ({advarsler.length}) - Gjøres på kontoret</h4>
            <p className="kjr-description">
              Disse kan fylles inn senere på kontoret:
            </p>

            <div className="warning-list">
              {advarsler.slice(0, 5).map((advarsel, idx) => (
                <div key={idx} className="warning-item">
                  <div className="warning-icon">⚠️</div>
                  <div className="warning-content">
                    {advarsel.bygningsdel && <strong>{advarsel.bygningsdel}:</strong>} {advarsel.message}
                  </div>
                </div>
              ))}
              {advarsler.length > 5 && (
                <div className="more-warnings">
                  + {advarsler.length - 5} flere advarsler
                </div>
              )}
            </div>
          </div>
        )}

        {/* Sjekkliste hvis alt OK */}
        {canLeave && (
          <div className="kjr-section success-checklist">
            <h4>✅ KRITISKE SJEKKER FULLFØRT</h4>
            <ul className="checklist">
              <li>✅ Alle påkrevde områder inspisert</li>
              <li>✅ TGIU har begrunnelser</li>
              <li>✅ TG2/TG3 har bilder</li>
              <li>✅ Videre undersøkelser bekreftet</li>
            </ul>

            {advarsler.length > 0 && (
              <div className="office-reminder">
                <p><strong>📝 Husk på kontoret:</strong></p>
                <ul>
                  {advarsler.some(a => a.type === 'TG3_NO_COST') && (
                    <li>Fyll inn TG3-kostnadsestimater</li>
                  )}
                  {advarsler.some(a => a.type === 'TG2_NO_EXPLANATION') && (
                    <li>Skriv TG2-redegjørelser</li>
                  )}
                  {advarsler.some(a => a.type === 'FEW_IMAGES') && (
                    <li>Vurder om flere bilder trengs</li>
                  )}
                </ul>
              </div>
            )}
          </div>
        )}

        {/* Action buttons */}
        <div className="kjr-actions">
          {canLeave ? (
            <>
              <button className="btn-primary large" onClick={onClose}>
                ✅ OK, JEG REISER NÅ
              </button>
              {kritiskeFeil.length === 0 && advarsler.length > 0 && (
                <button className="btn-secondary" onClick={onClose}>
                  Fikse advarsler likevel
                </button>
              )}
            </>
          ) : (
            <>
              <button
                className="btn-danger large"
                onClick={() => onFixError(kritiskeFeil[0])}
              >
                🔧 FIKSE MANGLER NÅ
              </button>
              <button className="btn-secondary" onClick={onClose}>
                Avbryt
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default KanJegReise;
